export const isBrowser = () => typeof window !== "undefined";

export const environment = {
  production: true,
  // API_PATH: `https://sb.vrutti.app/api/v1/public/`, // sb server
  // API_PATH: `http://localhost:3001/api/v1/public/`, // development server
  // API_PATH: `http://172.17.0.51:3001/api/v1/public/`, // development server
  API_PATH: `https://uat.swaminarayanbhagwan.org/api/v1/public/`, // development server
  // API_PATH: 'http://192.168.103.125:9000/', // local server
  //   API_PATH: "https://animeo.vrutti.app/"
};

if (environment.production && isBrowser()) {
  // Only run this logic in the browser and when in production. Will not work in docker
  const parsedUrl = new URL(window.location.href);
  const dynamicUrl = parsedUrl.origin;

  // if dynamicURL is with port number then we need to create API_PATH with port number+1 than dynamicURL port number
  console.log("dynamicUrl: ", window.location);
  if (window.location.port) {
    console.log("A");
    //parse the port number and hostname from dynamicURL via split from :
    environment.API_PATH = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/api/v1/public";
  } else {
    console.log("B");
    environment.API_PATH = dynamicUrl + "/api/v1/public";
  }
  console.log("environment.API_PATH: ", environment.API_PATH);
}
